/* Diver Bubbles — best-sellers grid: per-cell image cycling arrows + a
   quick-view modal (db-qv). The cart icon fetches /products/<handle>.js,
   renders title / price / option buttons / qty stepper, then adds to the
   cart via /cart/add.js (Dawn cart drawer re-rendered when available) or
   jumps straight to checkout via a cart permalink for Buy it now. */
(function () {
  if (window.__dbBS) return;
  window.__dbBS = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function fmtMoney(cents) {
    /* The shop money format often wraps the amount in <span class="money">…</span>;
       strip any HTML so we never print raw tags into textContent. */
    var fmt = (window.__dbMoneyFmt || '${{amount}}').replace(/<[^>]*>/g, '').trim();
    var n = cents / 100;
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var val;
    if (key === 'amount_no_decimals' || key === 'amount_no_decimals_with_comma_separator') {
      val = Math.round(n).toString();
    } else if (key === 'amount_with_comma_separator') {
      val = n.toFixed(2).replace('.', ',');
    } else {
      val = n.toFixed(2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, val);
  }

  function sized(src, w) {
    if (!src) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function cartAdd(id, qty, done, fail) {
    var cartEl = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var payload = { items: [{ id: id, quantity: qty }] };
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      try {
        payload.sections = cartEl.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = window.location.pathname;
      } catch (err) {}
    }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); }).then(function (d) {
      if (d.status) { fail(); return; }
      if (cartEl && typeof cartEl.renderContents === 'function') cartEl.renderContents(d);
      done();
    }).catch(fail);
  }

  /* ---- Quick-view modal ---- */
  var qv = null, qvState = null, lastFocus = null;

  function normOptions(p) {
    return p.options.map(function (opt, i) {
      var name = typeof opt === 'string' ? opt : (opt && opt.name) || 'Option';
      var values = (opt && opt.values) ? opt.values.slice() : [];
      if (!values.length) {
        p.variants.forEach(function (v) {
          var val = v['option' + (i + 1)];
          if (val && values.indexOf(val) === -1) values.push(val);
        });
      }
      return { name: name, values: values };
    });
  }

  function currentVariant() {
    if (!qvState) return null;
    var sel = qvState.sel;
    for (var i = 0; i < qvState.product.variants.length; i++) {
      var v = qvState.product.variants[i];
      var match = true;
      for (var j = 0; j < sel.length; j++) {
        if (v['option' + (j + 1)] !== sel[j]) { match = false; break; }
      }
      if (match) return v;
    }
    return null;
  }

  function getQty() {
    var input = qv.querySelector('.db-qv__qty input');
    var n = parseInt(input.value, 10);
    if (!n || n < 1) n = 1;
    input.value = n;
    return n;
  }

  function stepQty(d) {
    var input = qv.querySelector('.db-qv__qty input');
    var n = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, n + d);
  }

  function renderPrice() {
    var v = currentVariant();
    var now = qv.querySelector('.db-qv__now');
    var was = qv.querySelector('.db-qv__was');
    var pct = qv.querySelector('.db-qv__pct');
    var add = qv.querySelector('.db-qv__add');
    var buy = qv.querySelector('.db-qv__buy');
    if (!v) {
      add.disabled = true;
      buy.disabled = true;
      add.querySelector('span').textContent = 'Unavailable';
      return;
    }
    now.textContent = fmtMoney(v.price);
    if (v.compare_at_price && v.compare_at_price > v.price) {
      was.textContent = fmtMoney(v.compare_at_price);
      was.hidden = false;
      pct.textContent = '-' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
      pct.hidden = false;
    } else {
      was.hidden = true;
      pct.hidden = true;
    }
    add.disabled = !v.available;
    buy.disabled = !v.available;
    add.querySelector('span').textContent = v.available ? 'Add to cart' : 'Sold out';
  }

  function renderOpts() {
    var wrap = qv.querySelector('.db-qv__opts');
    wrap.innerHTML = '';
    var opts = qvState.opts;
    if (opts.length === 1 && opts[0].values.length === 1) return; /* single variant — nothing to pick */
    opts.forEach(function (opt, oi) {
      var group = document.createElement('div');
      group.className = 'db-qv__opt';
      var label = document.createElement('p');
      label.className = 'db-qv__optlabel';
      label.textContent = opt.name;
      group.appendChild(label);
      var row = document.createElement('div');
      row.className = 'db-qv__optrow';
      opt.values.forEach(function (val) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'db-qv__optbtn';
        b.textContent = val;
        if (qvState.sel[oi] === val) b.classList.add('is-selected');
        b.addEventListener('click', function () {
          qvState.sel[oi] = val;
          row.querySelectorAll('.db-qv__optbtn').forEach(function (x) {
            x.classList.toggle('is-selected', x === b);
          });
          renderPrice();
        });
        row.appendChild(b);
      });
      group.appendChild(row);
      wrap.appendChild(group);
    });
  }

  function closeQV() {
    if (!qv || qv.hidden) return;
    qv.hidden = true;
    document.documentElement.classList.remove('db-qv-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function buildQV() {
    if (qv) return;
    qv = document.createElement('div');
    qv.className = 'db-qv';
    qv.hidden = true;
    qv.innerHTML = '<div class="db-qv__backdrop" data-qv-close></div>' +
      '<div class="db-qv__panel" role="dialog" aria-modal="true" aria-label="Quick view">' +
      '<button type="button" class="db-qv__close" data-qv-close aria-label="Close">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
      '</button>' +
      '<div class="db-qv__media"></div>' +
      '<div class="db-qv__body">' +
      '<div class="db-qv__scroll">' +
      '<h3 class="db-qv__title"></h3>' +
      '<div class="db-qv__pricerow"><span class="db-qv__now"></span><s class="db-qv__was" hidden></s><span class="db-qv__pct" hidden></span></div>' +
      '<div class="db-qv__opts"></div>' +
      '</div>' +
      '<div class="db-qv__foot">' +
      '<div class="db-qv__buyrow">' +
      '<div class="db-qv__qty">' +
      '<button type="button" data-qv-minus aria-label="Decrease quantity">&minus;</button>' +
      '<input type="text" inputmode="numeric" value="1" aria-label="Quantity">' +
      '<button type="button" data-qv-plus aria-label="Increase quantity">+</button>' +
      '</div>' +
      '<button type="button" class="db-qv__add">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M6 7h12l1 13H5L6 7Z"/><path d="M9 9V6a3 3 0 0 1 6 0v3"/><path d="M12 12v5m-2.5-2.5h5"/></svg>' +
      '<span>Add to cart</span>' +
      '</button>' +
      '</div>' +
      '<button type="button" class="db-qv__buy">Buy it now</button>' +
      '</div>' +
      '</div>' +
      '</div>';
    document.body.appendChild(qv);

    qv.addEventListener('click', function (e) {
      /* close on the X, the backdrop, or any click outside the panel */
      if (e.target.closest('[data-qv-close]') || !e.target.closest('.db-qv__panel')) closeQV();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && qv && !qv.hidden) closeQV();
    });
    qv.querySelector('[data-qv-minus]').addEventListener('click', function () { stepQty(-1); });
    qv.querySelector('[data-qv-plus]').addEventListener('click', function () { stepQty(1); });
    qv.querySelector('.db-qv__add').addEventListener('click', function () {
      var v = currentVariant();
      if (!v || !v.available) return;
      var btn = qv.querySelector('.db-qv__add');
      btn.disabled = true;
      cartAdd(v.id, getQty(), function () {
        btn.disabled = false;
        closeQV();
      }, function () {
        btn.disabled = false;
        window.location.href = qvState.url;
      });
    });
    qv.querySelector('.db-qv__buy').addEventListener('click', function () {
      var v = currentVariant();
      if (!v || !v.available) return;
      window.location.href = root + 'cart/' + v.id + ':' + getQty();
    });
  }

  function openQV(url) {
    buildQV();
    lastFocus = document.activeElement;
    fetch(url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (p) {
        var first = null;
        for (var i = 0; i < p.variants.length; i++) {
          if (p.variants[i].available) { first = p.variants[i]; break; }
        }
        if (!first) first = p.variants[0];
        var opts = normOptions(p);
        qvState = {
          product: p,
          opts: opts,
          url: url,
          sel: opts.map(function (o, i) { return first['option' + (i + 1)]; })
        };
        qv.querySelector('.db-qv__title').textContent = p.title;
        var media = qv.querySelector('.db-qv__media');
        media.innerHTML = '';
        var imgs = (p.images && p.images.length ? p.images : [p.featured_image]).slice(0, 4);
        imgs.forEach(function (src) {
          if (!src) return;
          var im = document.createElement('img');
          im.src = sized(src, 900);
          im.alt = p.title;
          im.loading = 'lazy';
          media.appendChild(im);
        });
        qv.querySelector('.db-qv__qty input').value = 1;
        renderOpts();
        renderPrice();
        qv.hidden = false;
        document.documentElement.classList.add('db-qv-open');
        qv.querySelector('.db-qv__close').focus();
      })
      .catch(function () { window.location.href = url; });
  }

  /* ---- Grid ---- */
  function init() {
    document.querySelectorAll('[data-db-bs]').forEach(function (grid) {
      if (grid.dataset.dbBsBound) return;
      grid.dataset.dbBsBound = '1';
      grid.querySelectorAll('.db-bs__cell').forEach(function (cell) {
        var imgs = Array.prototype.slice.call(cell.querySelectorAll('.db-bs__img'));
        var prev = cell.querySelector('.db-bs__arrow--prev');
        var next = cell.querySelector('.db-bs__arrow--next');
        var idx = 0;
        var show = function (i) {
          idx = ((i % imgs.length) + imgs.length) % imgs.length;
          imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === idx); });
        };
        if (imgs.length < 2) {
          if (prev) prev.remove();
          if (next) next.remove();
        } else {
          if (prev) prev.addEventListener('click', function () { show(idx - 1); });
          if (next) next.addEventListener('click', function () { show(idx + 1); });
        }
        var cartBtn = cell.querySelector('.db-bs__cart');
        if (cartBtn) {
          cartBtn.addEventListener('click', function () {
            openQV(cartBtn.getAttribute('data-url'));
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
